import React, { useEffect } from 'react';
import {
  Button,
  CardContent,
  CardHeader,
  CardTitle,
} from '@sandtech-hub-monorepo/ui-kit';
import { GetCurrentCheckInQuery } from '@sandtech-hub-monorepo/ehub-client';
import { LucideCheck } from 'lucide-react';
import { formatDate } from 'date-fns';

interface SelectedHubPageProps {
  checkedInHubDetails: GetCurrentCheckInQuery['viewer']['currentCheckIn'];
  onClose: () => void;
}

export const CheckInSuccess = ({
  checkedInHubDetails,
  onClose,
}: SelectedHubPageProps) => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);

  const [now, setNow] = React.useState<number>(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <CardHeader>
        <CardTitle className="text-success text-xl text-center flex flex-col gap-2 items-center">
          <div className="bg-success/10 p-6 rounded-full inline-block">
            <LucideCheck size={50} />
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-2 sm:p-4 flex flex-col items-center -mt-6">
        <h2 className="text-2xl font-semibold text-center w-4/5">
          You have successfully checked into the {checkedInHubDetails?.hub.name}
        </h2>
        <h1 className="text-4xl font-semibold text-center mt-6">
          {formatDate(
            date.valueOf() +
              now -
              new Date(checkedInHubDetails!.checkedInAt!).valueOf(),
            'HH:mm:ss'
          )}
        </h1>
        <div className="font-light text-sm mt-1">Time spent at this hub</div>
        <div className="font-light text-text-primary mt-6 mb-4">
          Don’t forget to check out once you’re done
        </div>
        <Button variant="outline" onClick={onClose} className="mt-6">
          Done
        </Button>
      </CardContent>
    </>
  );
};
